var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000130648994518208878010000016025008013316741034_);}\n\t.st2{fill:#EAEAEA;}\n\t.st3{clip-path:url(#SVGID_00000160160336459789156440000013773701797511601834_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_00000168106964784191687090000011090046626013308086_);}\n\t.st6{fill:#EA4403;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 40,
  cy: 40,
  r: 40
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "a",
  width: 80,
  height: 80
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M80,40c0,22.09-17.91,40-40.001,40C17.91,80,0,62.09,0,40C0,17.907,17.91,0,39.999,0     C62.09,0,80,17.907,80,40"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "b",
  width: 80,
  height: 80
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "m24.346 28.556c-1.476 0-2.671 1.197-2.671 2.671v26.524c0 1.353 1.013 2.449 2.265 2.449h31.74c1.251 0 2.265-1.096 2.265-2.449v-26.524c0-1.474-1.196-2.671-2.671-2.671h-30.928z"
}));

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "d",
  width: 80,
  height: 80
}));

var _ref11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "m43.205 42.046v-28.149c0-0.64-0.518-1.16-1.158-1.16h-4.293c-0.64 0-1.158 0.519-1.158 1.16v28.18l-7.36 0.033c-1.03 4e-3 -1.542 1.251-0.813 1.978l10.121 10.121c0.44 0.441 1.15 0.453 1.607 0.029l11.015-10.215c0.775-0.718 0.263-2.014-0.793-2.008l-7.168 0.031z"
}));

var SvgDownloadConcrete = function SvgDownloadConcrete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 80 80",
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadConcrete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-concrete.2a991ae9.svg";
export { ForwardRef as ReactComponent };